import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db0823c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=db0823c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0823c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0823c4')) {
      api.createRecord('db0823c4', component.options)
    } else {
      api.reload('db0823c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db0823c4&scoped=true", function () {
      api.rerender('db0823c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LogManagement/supplementCollectionLog/index.vue"
export default component.exports